<script lang="ts" generics="ITEM">
    import {getLocalization} from 'src/core';
    import {states} from 'shared/constants';
    import type {Pagination, PaginationData} from '../search-manager/pagination';
    import type {ComponentSize} from 'shared/ui-widgets/types';
    import {strParams} from 'shared/utils/pipes';
    import {onDestroy} from 'svelte';
    import {cleanup, exists} from 'shared/utils/custom-utils';
    import {pipe} from 'core/utils';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';
    import KpPaginationButtons from './KpPaginationButtons.svelte';
    import KpSearchResultsLoadingContent from './KpSearchResultsLoadingContent.svelte';

    export let pagination: Pagination<ITEM>;
    export let loadingSize: ComponentSize = 'md';
    export let showPageButtons = true;
    export let showEmptyResultsMessage = true;
    export let loadNextButtonAdditionalClasses = '';
    export let loadPreviousButtonAdditionalClasses = '';

    const localize = getLocalization();

    let paginationData: PaginationData<ITEM> | undefined;
    const paginationDataSubscription = pagination.getPaginationData$().subscribe((data) => paginationData = data);

    onDestroy(() => {
        cleanup(paginationDataSubscription);
    });
</script>

{#if exists(paginationData)}
    <div class="kp-pageable-search-results">
        {#if paginationData.hasPreviousPage}
            <div class="pagination-buttons">
                <KpButton additionalClasses={loadPreviousButtonAdditionalClasses}
                          isLoading={paginationData.state.previousPage === states.PROCESSING}
                          on:click={() => pagination.requestPreviousPage()}>

                    <IconedContent icon="search">
                        {pipe(localize(/* @kp-localization vysledky.NacistPredchozichX */ 'vysledky.NacistPredchozichX'), strParams(paginationData.pageSize.toString()))}
                    </IconedContent>
                </KpButton>
            </div>
        {/if}

        <KpSearchResultsLoadingContent {paginationData} {loadingSize} {showEmptyResultsMessage}>
            <slot {paginationData}></slot>
        </KpSearchResultsLoadingContent>

        {#if paginationData.hasNextPage}
            <div class="pagination-buttons">
                <KpButton additionalClasses={loadNextButtonAdditionalClasses}
                          isLoading={paginationData.state.nextPage === states.PROCESSING}
                          on:click={() => pagination.requestNextPage()}>

                    <IconedContent icon="search">
                        {#if !paginationData.pageSize}
                            {localize(/* @kp-localization vysledky.NacistDalsichX */ 'vysledky.NacistDalsi')}
                        {:else}
                            {pipe(localize(/* @kp-localization vysledky.NacistDalsichX */ 'vysledky.NacistDalsichX'), strParams(paginationData.pageSize.toString()))}
                        {/if}
                    </IconedContent>
                </KpButton>
            </div>
        {/if}

        {#if showPageButtons}
            <KpPaginationButtons {paginationData}
                                 on:request-page={(event) => pagination.requestPage({pageNumber: event.detail})}/>
        {/if}
    </div>
{/if}

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";

    .kp-pageable-search-results {
        display: flex;
        flex-direction: column;
        gap: @panel-body-padding;
    }

    .pagination-buttons {
        display: flex;
        flex-direction: row;
        justify-content: center;
        gap: 2em;
    }
</style>